(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["short-video-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__shortVideoStripInitialized) return;
    window.__shortVideoStripInitialized = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-short-video-open]');
      if (openButton) {
        const dialogId = openButton.getAttribute('data-short-video-open');
        const dialog = document.getElementById(dialogId);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          // Play video when dialog opens
          const video = dialog.querySelector('video');
          if (video) {
            video.play().catch(() => {
              // Ignore autoplay errors (browser may block)
            });
          }
          // For iframes (YouTube/Vimeo), update src to autoplay version
          const iframe = dialog.querySelector('iframe[data-video-src-autoplay]');
          if (iframe) {
            iframe.src = iframe.getAttribute('data-video-src-autoplay');
          }
        }
        return;
      }

      const closeButton = event.target.closest('[data-short-video-close]');
      if (closeButton) {
        const dialog = closeButton.closest('dialog');
        if (dialog) {
          const video = dialog.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0; // Reset to beginning
          }
          // Reset iframe src to stop YouTube/Vimeo playback
          const iframe = dialog.querySelector('iframe[data-video-src-autoplay]');
          if (iframe) {
            const baseSrc = iframe.src.split('?')[0];
            iframe.src = baseSrc;
          }
          dialog.close();
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const dialog = document.querySelector('.short-video-dialog[open]');
      if (dialog) {
        const video = dialog.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        const iframe = dialog.querySelector('iframe[data-video-src-autoplay]');
        if (iframe) {
          const baseSrc = iframe.src.split('?')[0];
          iframe.src = baseSrc;
        }
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
